import template from "./qr_code.html";
import QRCode from "qrcode";

class QRCodeController {
    /* @ngInject */
    constructor($q) {
        this.$q = $q;
    }

    $onInit() {
        let ctrl = this;
        ctrl.$q
            .when(QRCode.toDataURL(ctrl.content, { errorCorrectionLevel: "L" }))
            .then((url) => {
                ctrl.url = url;
            });
    }
}

export default {
    bindings: {
        content: "<",
        classes: "@",
    },
    name: "qrCodeGenerator",
    controller: QRCodeController,
    template: template,
};
